import { create } from "zustand";

type SettingState = {
    selectedCategory: string;
    setSelectedCategory: (category: string) => void;
};

export const useSettingStore = create<SettingState>((set: any) => ({
    selectedCategory: "고객",
    setSelectedCategory: (category: string) => set({ selectedCategory: category }),
}));
